/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

function stoppingReason(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.stopping_reason = healthEntryCategoryState.stopping_reason || { id: null, strings: {} };

  let stoppingReasonsThatAreReactions = [];

  return {
    get: () => healthEntryCategoryState.stopping_reason,
    replaceWithSearchTerm: (searchTerm) => {
      healthEntryCategoryState.stopping_reason = {
        id: searchTerm.id,
        strings: {
          [languageCode]: searchTerm.string,
        },
      };
    },
    remove: () => { healthEntryCategoryState.stopping_reason = { id: null, strings: {} }; },
    hasStoppingReason: () => !!healthEntryCategoryState.stopping_reason.id,
    text: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return healthEntryCategoryState.stopping_reason.strings[code];
    },
    shouldDisplay: () => !healthEntryCategoryState.current,
    isReaction: () => !!healthEntryCategoryState.stopping_reason.id && stoppingReasonsThatAreReactions.filter((c) => c.id === healthEntryCategoryState.stopping_reason.id).length > 0,
    setStoppingReasonsThatAreReactions: (stoppingReasons) => { stoppingReasonsThatAreReactions = stoppingReasons; },
  };
}


export function cleanStoppingReason(healthEntryCategoryState) {
  const stopppingId = _.get(healthEntryCategoryState, 'stopping_reason.id', '');
  if (stopppingId === '' || stopppingId === null) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['stopping_reason']);
  } else if (healthEntryCategoryState.current) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['stopping_reason']);
  }
  return healthEntryCategoryState;
}

export default stoppingReason;
